import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../utils/constant';

export const adminLogin = createAsyncThunk('auth/adminLogin', async (credentials, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/admin/login`, credentials);
    return response.data;
  } catch (err) {
    return rejectWithValue(err.response.data);
  }
});


// Company login
export const companyLogin = createAsyncThunk('auth/companyLogin', async (credentials, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/companies/auth/login`, credentials);
    return response.data;
  } catch (err) {
    return rejectWithValue(err.response.data);
  }
});

const authSlice = createSlice({
  name: 'adminauth',
  initialState: {
    admin: null,
    company: null,
    loading: false,
    error: null
  },
  reducers: {
    logout(state) {
      state.admin = null;
      state.company = null;
      state.token = null;
      localStorage.removeItem('admin');
      localStorage.removeItem('company');
    },
    clearMessage: (state) => {
      state.message = null;
      state.error = null;
    },
    setCompanyFromLocalStorage: (state, action) => {
      state.company = action.payload;
    },
    setUserFromLocalStorage: (state, action) => {
        state.admin = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(adminLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.admin = action.payload;
        localStorage.setItem('admin', JSON.stringify(action.payload));
      })
      .addCase(adminLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(companyLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(companyLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.company = action.payload;
        // console.log('con. state', action.payload);
        localStorage.setItem('user_id', action.payload.user_id);
        localStorage.setItem('userType', action.payload.userType);
        localStorage.setItem('user_name', action.payload.user_name);
        localStorage.setItem('user_email', action.payload.user_email);
        localStorage.setItem('companyID', action.payload.companyID);
        localStorage.setItem('userRole', action.payload.userRole);
        localStorage.setItem('permissions', action.payload.permissions);
        localStorage.setItem('module_permissions', action.payload.module_permissions);
        localStorage.setItem('company_state', action.payload.company?.state);
        localStorage.setItem('company', JSON.stringify(action.payload));
      })
      .addCase(companyLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { logout, clearMessage, setCompanyFromLocalStorage,setUserFromLocalStorage } = authSlice.actions;
export default authSlice.reducer;
